import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { InternalReferentialsBaseService } from "src/app/core/base/internal-referentials-base.service";
import { environment } from "src/environments/environment";
import { VatRate } from "./vat-rate.model";

export const VAT_RATE_BASE_URL = `${environment.baseUrl}/engine/vat-rates`;

@Injectable({
  providedIn: "root",
})
export class VatRateService extends InternalReferentialsBaseService<
  VatRate,
  number
> {
  constructor() {
    const httpClient = inject(HttpClient);

    super(httpClient, VAT_RATE_BASE_URL);
  }
}
